<template>
  <div class="sidebar" id="sidebar">
    <div class="sidebar-inner slimscroll">
      <div id="sidebar-menu" class="sidebar-menu">
        <ul>
          <li class="menu-title">
            <span>Main</span>
          </li>
          <!-- <li class="submenu">
            <a href="#"
              ><i class="la la-dashboard"></i> <span> Dashboard</span>
              <span class="menu-arrow"></span
            ></a>
            <ul style="display: none">
              <li><router-link to="/">Admin Dashboard</router-link></li>
              <li v-can="{ any: ['ADMIN_VIEW'] }">
                <router-link to="/minh-tien-admin">Minh Tiến Admin</router-link>
              </li>
            </ul>
          </li> -->
          <li class="submenu"  v-can="{ any: ['WORKSPACE_VIEW'] }">
            <a href="#"
              ><i class="la la-user"></i> <span>Công việc</span>
              <span class="menu-arrow"></span
            ></a>
            <ul style="display: none">
              <li>
                <router-link to="/dashboard-tong-quan-cong-viec"
                  >Thống kê</router-link
                >
              </li>
              <li>
                <router-link to="/"
                  >Bàn làm việc</router-link
                >
              </li>
              <li>
                <router-link to="/luu-tru-cong-viec"
                  >Lưu trữ công việc</router-link
                >
              </li>
            </ul>
          </li>
          <li class="submenu" v-can="{ any: ['ADMIN_VIEW'] }">
  <a href="#">
    <i class="la la-building"></i> <span>Quản Lý Công Trình (demo)</span>
    <span class="menu-arrow"></span>
  </a>
  <ul style="display: none">
    <li>
      <router-link to="/quan-ly-cong-trinh">Danh sách dự án</router-link>
    </li>
    <li>
      <router-link to="/quan-ly-cong-trinh?action=create">Thêm công trình mới</router-link>
    </li>
  </ul>
</li>
          <li class="submenu">
            <a href="#"
              ><i class="la la-calendar-check-o"></i>
              <span> Chấm công & Lệnh</span>
              <span class="menu-arrow"></span
            ></a>
            <ul style="display: none">
              <li>
                <router-link to="/cham-cong-nhan-vien">Chấm công</router-link>
              </li>
              <li>
                <router-link to="/phieu-cong">Phiếu công</router-link>
              </li>
              <li v-can="{ any: ['PHEP_VIEW'] }">
                <router-link to="/quan-ly-phep">Quản lý phép</router-link>
              </li>
              <li v-can="{ any: ['LE_VIEW'] }">
                <router-link to="/quan-ly-le">Quản lý lễ</router-link>
              </li>
              <li v-can="{ any: ['LE_VIEW'] }">
                <router-link to="/quan-ly-dia-diem-cham-cong">Quản lý địa điểm chấm công</router-link>
              </li>
              <li v-can="{ any: ['ADMINCHAMCONG_VIEW'] }">
                <router-link to="/quan-ly-cham-cong"
                  >Quản lý chấm công</router-link
                >
              </li>
              <li v-can="{ any: ['ADMINCHAMCONG_VIEW'] }">
                <router-link to="/quan-ly-cham-cong-thoi-vu"
                  >Quản lý chấm công thời vụ</router-link
                >
              </li>
              <li v-can="{ any: ['ADMINCHAMCONG_VIEW'] }">
                <router-link to="/quan-ly-thoi-vu"
                  >Quản lý thời vụ</router-link
                >
              </li>
              <li v-can="{ any: ['LENH_VIEW'] }">
                <router-link to="/quan-ly-lenh">Quản lý lệnh</router-link>
              </li>
            </ul>
          </li>
          <li class="submenu">
            <a href="#"
              ><i class="la la-calendar-check-o"></i>
              <span> Sổ tay chi tiêu</span>
              <span class="menu-arrow"></span
            ></a>
            <ul style="display: none">
              <li>
                <router-link to="/so-tay-chi-tieu-nhan-vien">Sổ tay chi tiêu công ty</router-link>
              </li>
              <li v-can="{ any: ['PHEP_VIEW'] }">
                <router-link to="/thu-chi-admin-dashboard">Dashboard thu chi công ty</router-link>
              </li>
              <li v-can="{ any: ['PHEP_VIEW'] }">
                <router-link to="/thu-chi-admin-list">Quản lý phiếu thu chi công ty</router-link>
              </li>
              <li v-can="{ any: ['PHEP_VIEW'] }">
                <router-link to="/quan-ly-danh-muc-thu-chi">Quản lý danh mục thu chi công ty</router-link>
              </li>
            </ul>
          </li>
          <li class="submenu">
            <a href="#">
              <i class="la la-file"></i> <span>Quy định, Hướng dẫn</span>
              <span class="menu-arrow"></span>
            </a>
            <ul style="display: none">
              <li v-can="{ any: ['NOIQUY_VIEW'] }">
                <router-link to="/noi-quy/them-moi">Tạo mới</router-link>
              </li>
              <li v-can="{ any: ['NOIQUY_VIEW'] }">
                <router-link to="/noi-quy">Danh sách nội quy, hướng dẫn</router-link>
              </li>
              <li>
                <router-link to="/noi-quy-cua-toi">Nội quy</router-link>
              </li>
              <li>
                <router-link to="/quy-dinh-cua-toi">Quy định</router-link>
              </li>
              <li>
                <router-link to="/huong-dan-cua-toi">Hướng dẫn</router-link>
              </li>
            </ul>
          </li>

          <li class="submenu">
            <a href="#">
              <i class="la la-bullhorn"></i> 
              <span>Góp ý, Phản ánh</span>
              <span class="menu-arrow"></span>
            </a>
            <ul style="display: none">
              <li>
                <router-link to="/gop-y-kien-nghi/tao-moi">Tạo ý kiến mới</router-link>
              </li>

              <li>
                <router-link to="/gop-y-kien-nghi/lich-su">Ý kiến của tôi</router-link>
              </li>

              <li v-can="{ any: ['PHANANH_KIENNGHI_VIEW'] }">
                <router-link to="/gop-y-kien-nghi/quan-ly">Tiếp nhận & Xử lý</router-link>
              </li>

              <li v-can="{ any: ['PHANANH_KIENNGHI_VIEW'] }">
                <router-link to="/quan-ly-danh-muc-bao-cao">Danh mục</router-link>
              </li>
            </ul>
          </li>

          <li class="menu-title" v-can="{ any: ['ADMIN_VIEW'] }">
            <span>Bán hàng</span>
          </li>
          <li class="submenu" v-can="{ any: ['ADMIN_VIEW'] }">
            <a href="#"
              ><i class="la la-file-invoice-dollar"></i> <span>Báo giá</span>
              <span class="menu-arrow"></span
            ></a>
            <ul style="display: none">
              <li v-can="{ any: ['ADMIN_VIEW'] }">
                <router-link to="/bao-gia-nhanh">Báo giá nhanh</router-link>
              </li>
            </ul>
          </li>
           <li class="submenu" v-can="{ any: ['TAODONGIAO_VIEW', 'ADMIN_VIEW'] }">
            <a href="#"
              ><i class="fa fa-money"></i> <span>Bán Hàng</span>
              <span class="menu-arrow"></span
            ></a>
            <ul style="display: none">
               <li v-can="{ any: ['ADMIN_VIEW'] }">
                <router-link to="/quan-ly-don-hang"
                  >Quản lý đơn giao</router-link>
              </li>
              <li v-can="{ any: ['TAODONGIAO_VIEW'] }">
                <router-link to="/quan-ly-don-hang-sales"
                  >Tạo Đơn giao</router-link>
              </li>
            </ul>
          </li>

          <li class="submenu" v-can="{ any: ['QUANLYKHO_VIEW', 'NHANVIENKHO_VIEW'] }">
            <li class="menu-title">
              <span>Kho</span>
            </li>
            <a href="#"
              ><i class="la la-users"></i> <span>Kho</span>
              <span class="menu-arrow"></span
            ></a>
            <ul style="display: none" v-can="{ any: ['QUANLYKHO_VIEW', 'NHANVIENKHO_VIEW'] }">
              <li v-can="{ any: ['QUANLYKHO_VIEW'] }">
                <router-link to="/quan-ly-don-hang-kho" 
                  >Quản lý Kho</router-link>
                </li>
              <li v-can="{ any: ['NHANVIENKHO_VIEW'] }">
              <router-link to="/nhan-vien-kho"
                  >Nhân viên kho</router-link>
                </li>
              </ul>
          </li>

          <li class="submenu" v-can="{ any: ['DIEUPHOI_VIEW'] }">
            <li class="menu-title">
              <span>Điều phối</span>
            </li>
            <a href="#"
              ><i class="la la-users"></i> <span>Điều phối</span>
              <span class="menu-arrow"></span
            ></a>
            <ul style="display: none" v-can="{ any: ['DIEUPHOI_VIEW'] }">
                <li v-can="{ any: ['DIEUPHOI_VIEW'] }">
              <router-link to="/quan-ly-don-hang-dieu-phoi"
                  >Quản lý điều phối</router-link>
                </li>
              </ul>
          </li>

          <li class="submenu" v-can="{ any: ['TAIXE_VIEW'] }">
            <li class="menu-title">
              <span>Tài Xế</span>
            </li>
            <a href="#"
              ><i class="la la-id-card"></i> <span>Tài Xế</span>
              <span class="menu-arrow"></span
            ></a>
            <ul style="display: none">
              <li v-can="{ any: ['TAIXE_VIEW'] }">
                <router-link to="/tai-xe">Tài Xế</router-link>
              </li>
            </ul>
          </li>

          <li class="menu-title" v-can="{ any: ['KHOANLUONG_VIEW', 'LUONG_VIEW'] }">
            <span>Kế toán</span>
          </li>
          <li class="submenu" v-can="{ any: ['KHOANLUONG_VIEW', 'LUONG_VIEW'] }">
            <a href="#"
              ><i class="la la-file-invoice-dollar"></i> <span>Lương</span>
              <span class="menu-arrow"></span
            ></a>
            <ul style="display: none">
              <li v-can="{ any: ['KHOANLUONG_VIEW'] }">
                <router-link to="/quan-ly-khoan-luong">Quản lý khoản lương</router-link>
              </li>
              <li v-can="{ any: ['LUONG_VIEW'] }">
                <router-link to="/quan-ly-luong">Quản lý lương</router-link>
              </li>
            </ul>
          </li>

          <li
            class="menu-title"
            v-can="{
              any: [
                'XE_VIEW',             
                'GIAYTO_VIEW',
                'BAODUONGXE_VIEW',
                'CHECKLIST_VIEW',
                'XANGDAU_VIEW',
                'XEASSIGNMENT_VIEW',
                'DMLOAIXE_VIEW',
                'DMCHECKLIST_VIEW',
                'DMHANGMUCBAODUONG_VIEW',
              ],
            }"
          >
            <span>Quản lý Vận tải</span>
          </li>
                <li
            class="submenu"
            v-can="{
              any: [
                'XE_VIEW',
                'GIAYTO_VIEW',
                'BAODUONGXE_VIEW',
                'CHECKLIST_VIEW',
                'XANGDAU_VIEW',
                'XEASSIGNMENT_VIEW',
              ],
            }"
          >
            <a href="#"
              ><i class="fa fa-bar-chart"></i><span>Báo cáo Vận Tải</span>
              <span class="menu-arrow"></span
            ></a>
            <ul style="display: none">
              <li v-can="{ any: ['ADMIN_VIEW'] }">
                <router-link to="/bao-cao-xang-dau">Báo cáo xăng dầu</router-link>
              </li>
          

            </ul>
          </li>
          <li
            class="submenu"
            v-can="{
              any: [
                'XE_VIEW',
                'GIAYTO_VIEW',
                'BAODUONGXE_VIEW',
                'CHECKLIST_VIEW',
                'XANGDAU_VIEW',
                'XEASSIGNMENT_VIEW',
                'DMLOAIXE_VIEW',
                'DMCHECKLIST_VIEW',
                'DMHANGMUCBAODUONG_VIEW',
              ],
            }"
          >
            <a href="#"
              ><i class="la la-truck"></i> <span>Quản Lý Vận Tải</span>
              <span class="menu-arrow"></span
            ></a>
            <ul style="display: none">
               <li v-can="{ any: ['ADMIN_VIEW'] }">
                <router-link to="/quan-ly-giao-nhan-hang">Quản lý giao nhận hàng</router-link>
              </li>
              <li v-can="{ any: ['XEASSIGNMENT_VIEW'] }">
                <router-link to="/phan-cong-xe">Lệnh Giao Xe</router-link>
              </li>
          
              <li v-can="{ any: ['XE_VIEW'] }">
                <router-link to="/danh-sach-xe">Danh sách xe</router-link>
              </li>

              <li v-can="{ any: ['GIAYTO_VIEW'] }">
                <router-link to="/quan-ly-giay-to">Giấy tờ</router-link>
              </li>
              <li v-can="{ any: ['BAODUONGXE_VIEW'] }">
                <router-link to="/quan-ly-bao-duong"
                  >Quản lý bảo dưỡng</router-link
                >
              </li>
              <li v-can="{ any: ['CHECKLIST_VIEW'] }">
                <router-link to="/quan-ly-checklist"
                  >Quản lý checklist</router-link
                >
              </li>
              <li v-can="{ any: ['XANGDAU_VIEW'] }">
                <router-link to="/quan-ly-xang-dau"
                  >Quản lý xăng dầu</router-link
                >
              </li>
                <li v-can="{ any: ['DMLOAIXE_VIEW'] }">
                <router-link to="/quan-ly-loai-xe">Loại xe</router-link>
              </li>
              <li v-can="{ any: ['DMCHECKLIST_VIEW'] }">
                <router-link to="/hang-muc-checklist"
                  >Hạng mục checklist</router-link
                >
              </li>
              <li v-can="{ any: ['DMHANGMUCBAODUONG_VIEW'] }">
                <router-link to="/hang-muc-bao-duong"
                  >Hạng mục bảo dưỡng</router-link
                >
              </li>
            </ul>
          </li>

          <li
            class="menu-title"
            v-can="{
              any: [
                'KHACHHANGTIEMNANG_VIEW',
                'FANPAGE_VIEW',
                'CONGTY_VIEW',
                'INDUSTRY_VIEW',
              ],
            }"
          >
            <span>Marketing & Dữ liệu</span>
          </li>
          <li class="submenu" v-can="{ any: ['KHACHHANGTIEMNANG_VIEW'] }">
            <a href="#"
              ><i class="la la-users"></i> <span>Khách hàng</span>
              <span class="menu-arrow"></span
            ></a>
            <ul style="display: none">
              <li v-can="{ any: ['KHACHHANGTIEMNANG_VIEW'] }">
                <router-link to="/danh-sach-khach-hang-tiem-nang"
                  >Danh sách khách hàng</router-link
                >
              </li>
            </ul>
          </li>
          <li class="submenu" v-can="{ any: ['FANPAGE_VIEW'] }">
            <a href="#"
              ><i class="la la-columns"></i> <span> Fanpage</span>
              <span class="menu-arrow"></span
            ></a>
            <ul style="display: none">
              <li v-can="{ any: ['FANPAGE_VIEW'] }">
                <router-link to="/quan-ly-fanpage">Quản lý Fanpage</router-link>
              </li>
              <li v-can="{ any: ['FANPAGE_VIEW'] }">
                <router-link to="/post-fb">Bài viết trên Fanpage</router-link>
              </li>
            </ul>
          </li>
          <li class="submenu" v-can="{ any: ['CONGTY_VIEW', 'INDUSTRY_VIEW'] }">
            <a href="#"
              ><i class="la la-file-text"></i> <span>Dữ liệu công ty</span>
              <span class="menu-arrow"></span
            ></a>
            <ul style="display: none">
              <li v-can="{ any: ['CONGTY_VIEW'] }">
                <router-link to="/">Lấy dữ liệu Maps</router-link>
              </li>
              <li v-can="{ any: ['CONGTY_VIEW'] }">
                <router-link to="/lay-du-lieu-trang-vang"
                  >Lấy dữ liệu trang vàng</router-link
                >
              </li>
              <li v-can="{ any: ['CONGTY_VIEW'] }">
                <router-link to="/danh-sach-cong-ty"
                  >Danh sách công ty</router-link
                >
              </li>
              <li v-can="{ any: ['INDUSTRY_VIEW'] }">
                <router-link to="/danh-sach-nganh-nghe"
                  >Danh sách ngành nghề</router-link
                >
              </li>
            </ul>
          </li>

          <li
            class="menu-title"
            v-can="{ any: ['ADMIN_VIEW', 'VIETBAI_VIEW', 'TAINGUYEN_VIEW'] }"
          >
            <span>Công cụ & Tài nguyên</span>
          </li>
          <li
            class="submenu"
            v-can="{
              any: ['VIETBAI_VIEW', 'CTA_VIEW', 'WPSITE_VIEW'],
            }"
          >
            <a href="#"
              ><i class="la la-cube"></i> <span> Ứng dụng</span>
              <span class="menu-arrow"></span
            ></a>
            <ul style="display: none">
              <li v-can="{ any: ['VIETBAI_VIEW', 'CTA_VIEW', 'WPSITE_VIEW'] }">
                <router-link to="/dashboard-viet-bai-user"
                  >Viết bài tự động</router-link
                >
              </li>
            </ul>
          </li>
          <li class="submenu" v-can="{ any: ['TAINGUYEN_VIEW'] }">
            <a href="#"
              ><i class="la la-ticket"></i> <span> Tài nguyên</span>
              <span class="menu-arrow"></span
            ></a>
            <ul style="display: none">
              <li v-can="{ any: ['TAINGUYEN_VIEW'] }">
                <router-link to="/quan-ly-tai-nguyen"
                  >Quản lý tài nguyên</router-link
                >
              </li>
            </ul>
          </li>

          <li
            class="menu-title"
            v-can="{
              any: [
                'NGUOIDUNG_VIEW',
                'PHONGBAN_VIEW',
                'CHUCVU_VIEW',
                'QUYEN_VIEW',
                'CHUCNANG_VIEW',
                'HANHDONG_VIEW',
                'PERMISSION_VIEW',
              ],
            }"
          >
            <span>Quản lý hệ thống</span>
          </li>
          <li class="submenu" v-can="{ any: ['NGUOIDUNG_VIEW'] }">
            <a href="#" class="noti-dot"
              ><i class="la la-user"></i> <span> Quản lý Tài khoản</span>
              <span class="menu-arrow"></span
            ></a>
            <ul style="display: none">
              <li v-can="{ any: ['NGUOIDUNG_VIEW'] }">
                <router-link to="/employees-list">Tất cả tài khoản</router-link>
              </li>
            </ul>
          </li>
          <li class="submenu" v-can="{ any: ['PHONGBAN_VIEW'] }">
            <a href="#"
              ><i class="la la-sitemap"></i> <span>Phòng Ban</span>
              <span class="menu-arrow"></span
            ></a>
            <ul style="display: none">
              <li v-can="{ any: ['PHONGBAN_VIEW'] }">
                <router-link to="/phong-ban">Danh sách phòng ban</router-link>
              </li>
            </ul>
          </li>
          <li class="submenu" v-can="{ any: ['CHUCVU_VIEW'] }">
            <a href="#"
              ><i class="la la-briefcase"></i> <span>Chức Vụ</span>
              <span class="menu-arrow"></span
            ></a>
            <ul style="display: none">
              <li v-can="{ any: ['CHUCVU_VIEW'] }">
                <router-link to="/chuc-vu">Danh sách chức vụ</router-link>
              </li>
            </ul>
          </li>
          <li
            class="submenu"
            v-can="{
              any: [
                'QUYEN_VIEW',
                'CHUCNANG_VIEW',
                'HANHDONG_VIEW',
                'PERMISSION_VIEW',
              ],
            }"
          >
            <a href="#"
              ><i class="la la-key"></i> <span>Phân Quyền</span>
              <span class="menu-arrow"></span
            ></a>
            <ul style="display: none">
              <li v-can="{ any: ['QUYEN_VIEW'] }">
                <router-link to="/quyen">Danh sách quyền</router-link>
              </li>
              <li v-can="{ any: ['CHUCNANG_VIEW'] }">
                <router-link to="/chuc-nang">Danh sách chức năng</router-link>
              </li>
              <li v-can="{ any: ['HANHDONG_VIEW'] }">
                <router-link to="/hanh-dong">Danh sách hành động</router-link>
              </li>
              <li v-can="{ any: ['PERMISSION_VIEW'] }">
                <router-link to="/api-permission"
                  >Danh sách API Permission</router-link
                >
              </li>
            </ul>
          </li>




        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SidebarComponent",
  data() {
    return {
      // Dữ liệu của component
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (window.$) {
        if ($("html").hasClass("menu-opened")) {
          $("html").removeClass("menu-opened");
          $(".sidebar-overlay").removeClass("opened");
          $(".main-wrapper").removeClass("slide-nav");
          $("#task_window").removeClass("opened");
        }
        $(document).ready(() => {
          this.initializeLayoutPlugins();
        });
      } else {
        console.error(
          "jQuery is not loaded. Layout plugins cannot be initialized."
        );
      }
    });
  },
  beforeUnmount() {
    // Dọn dẹp tất cả trình lắng nghe sự kiện toàn cục
    if (window.$) {
      $(document).off("click", "#toggle_btn");
      $(document).off("click", "#mobile_btn");
      $(".sidebar-overlay").off("click").remove();
      $("#sidebar-menu a").off("click");
      $(window).off("resize.slimscroll");
      $(window).off("resize.pagewrapper");

      // Dọn dẹp trình hover (QUAN TRỌNG)
      $(document).off("mouseenter mouseleave", ".sidebar");
    }
  },
  methods: {
    initializeLayoutPlugins() {
      // === KHAI BÁO BIẾN ===
      var $wrapper = $(".main-wrapper");
      var $pageWrapper = $(".page-wrapper");
      var $slimScrolls = $(".slimscroll");

      // === THIẾT LẬP TRẠNG THÁI BAN ĐẦU ===
      // Buộc sidebar ở trạng thái MỞ RỘNG (ghim) khi tải trang
      if (
        !$("body").hasClass("mini-sidebar") &&
        !$("body").hasClass("sidebar-pinned")
      ) {
        $("body").addClass("sidebar-pinned"); // GHIM nó lại
        console.log("Forcing pinned sidebar on initial load.");
      }

      // === 1. KHỞI TẠO SLIMSCROLL ===
      if ($slimScrolls.length > 0) {
        $(window).off("resize.slimscroll");

        function handleSlimscrollResize() {
          try {
            var $headerHeight = $(".header").height() || 60;
            var wHeight = $(window).height() - $headerHeight;
            $slimScrolls.height(wHeight);
            $(".sidebar .slimScrollDiv").height(wHeight);
          } catch (e) {
            console.error("Error resizing slimscroll:", e);
          }
        }

        try {
          if (typeof $.fn.slimScroll === "function") {
            $slimScrolls.slimScroll({
              height: "auto",
              width: "100%",
              position: "right",
              size: "7px",
              color: "#ccc",
              wheelStep: 10,
              touchScrollStep: 100,
            });

            handleSlimscrollResize();
            $(window).on("resize.slimscroll", handleSlimscrollResize);
          } else {
            console.warn(
              "jQuery SlimScroll plugin is not loaded. Using native CSS scroll."
            );
            var $headerHeight = $(".header").height() || 60;
            var wHeight = $(window).height() - $headerHeight;
            $slimScrolls.css({
              "overflow-y": "auto",
              height: wHeight + "px",
            });
            $(window).on("resize.slimscroll", function () {
              var newHeight =
                $(window).height() - ($(".header").height() || 60);
              $slimScrolls.css("height", newHeight + "px");
            });
          }
        } catch (e) {
          console.error("Error initializing slimScroll: ", e);
        }
      }

      // === 2. SET MIN-HEIGHT CHO PAGE WRAPPER ===
      try {
        $(window).off("resize.pagewrapper");
        function handlePageWrapperResize() {
          var pHeight = $(window).height();
          $pageWrapper.css("min-height", pHeight);
        }
        handlePageWrapperResize();
        $(window).on("resize.pagewrapper", handlePageWrapperResize);
      } catch (e) {
        console.error("Error setting pageWrapper min-height: ", e);
      }

      // === 3. KHỞI TẠO CÁC PLUGIN UI KHÁC ===
      try {
        if ($.fn.tooltip && $('[data-toggle="tooltip"]').length > 0) {
          $('[data-toggle="tooltip"]').tooltip();
        }
      } catch (e) {
        console.warn("Tooltip init failed.", e);
      }

      try {
        if ($.fn.select2 && $(".select").length > 0) {
          $(".select").select2({
            minimumResultsForSearch: -1,
            width: "100%",
          });
        }
      } catch (e) {
        console.warn("Select2 init failed.", e);
      }

      try {
        if ($.fn.datetimepicker && $(".datetimepicker").length > 0) {
          $(".datetimepicker").datetimepicker({
            format: "DD/MM/YYYY",
            icons: {
              up: "fa fa-angle-up",
              down: "fa fa-angle-down",
              next: "fa fa-angle-right",
              previous: "fa fa-angle-left",
            },
          });
        }
      } catch (e) {
        console.warn("Datetimepicker init failed.", e);
      }

      // === 4. LOGIC NÚT "GHIM" (PIN) SIDEBAR ===
      $(document)
        .off("click", "#toggle_btn")
        .on("click", "#toggle_btn", function (e) {
          e.preventDefault();

          if ($("body").hasClass("mini-sidebar")) {
            // --- ĐANG THU NHỎ, CLICK ĐỂ "GHIM" MỞ RỘNG ---
            $("body").removeClass("mini-sidebar");
            $wrapper.removeClass("mini-sidebar");
            $("body").addClass("sidebar-pinned"); // Thêm class "ghim"

            // Khôi phục trạng thái menu con
            $("#sidebar-menu .submenu > ul").hide();
            $("#sidebar-menu li a.subdrop").next("ul").show();
          } else {
            // --- ĐANG MỞ RỘNG (HOẶC ĐANG GHIM), CLICK ĐỂ BỎ GHIM VÀ THU NHỎ ---
            $("body").removeClass("sidebar-pinned"); // Bỏ class "ghim"
            $("body").addClass("mini-sidebar");
            $wrapper.addClass("mini-sidebar");

            // Dọn dẹp style
            $("#sidebar-menu .submenu > ul").removeAttr("style");
            $("#sidebar-menu a").removeClass("subdrop");
          }
        });

      // === 5. XỬ LÝ SUBMENU CLICK (ĐÃ SỬA LỖI MOBILE) ===
      $("#sidebar-menu a")
        .off("click")
        .on("click", function (e) {
          var $this = $(this);
          var $parentLi = $this.parent();

          if ($parentLi.hasClass("submenu")) {
            // Đây là link cha (ví dụ: "Dashboard", "Ứng dụng")
            e.preventDefault();

            // CHỈ chạy animation slide KHI sidebar đang MỞ RỘNG (desktop)
            if (!$("body").hasClass("mini-sidebar")) {
              if (!$this.hasClass("subdrop")) {
                $("ul", $this.parents("ul:first")).slideUp(350);
                $("a", $this.parents("ul:first")).removeClass("subdrop");
                $this.next("ul").slideDown(350);
                $this.addClass("subdrop");
              } else if ($this.hasClass("subdrop")) {
                $this.removeClass("subdrop");
                $this.next("ul").slideUp(350);
              }
            }
          } else {
            // --- (FIX MỚI) ĐÂY LÀ LINK CON (router-link) ---
            // Tự động đóng menu mobile khi click vào link con
            // Chúng ta kiểm tra 'menu-opened' là class an toàn nhất cho biết mobile menu đang mở
            if ($("html").hasClass("menu-opened")) {
              $("html").removeClass("menu-opened");
              $(".sidebar-overlay").removeClass("opened");
              $(".main-wrapper").removeClass("slide-nav");
              $("#task_window").removeClass("opened");
            }
          }
        });

      // Khởi tạo active link (chỉ khi không ở mini-sidebar)
      if (!$("body").hasClass("mini-sidebar")) {
        $("#sidebar-menu ul li.submenu a.active")
          .parents("li.submenu:last")
          .children("a:first")
          .addClass("subdrop")
          .next("ul")
          .show();

        $("#sidebar-menu ul li a.active")
          .parents("li.submenu")
          .children("a:first")
          .addClass("subdrop");
      }

      // === 6. LOGIC HOVER ĐỂ MỞ RỘNG/THU NHỎ ===
      $(document).off("mouseenter mouseleave", ".sidebar");

      $(document).on("mouseenter", ".sidebar", function () {
        // CHỈ chạy khi sidebar KHÔNG BỊ GHIM và đang ở chế độ MINI
        if (
          !$("body").hasClass("sidebar-pinned") &&
          $("body").hasClass("mini-sidebar")
        ) {
          // --- MỞ RỘNG SIDEBAR ---
          $("body").removeClass("mini-sidebar");
          $wrapper.removeClass("mini-sidebar");

          // Khôi phục trạng thái menu con
          $("#sidebar-menu .submenu > ul").hide();
          $("#sidebar-menu li a.subdrop").next("ul").show();
        }
      });

      $(document).on("mouseleave", ".sidebar", function () {
        // CHỈ chạy khi sidebar KHÔNG BỊ GHIM và KHÔNG ở chế độ MINI
        if (
          !$("body").hasClass("sidebar-pinned") &&
          !$("body").hasClass("mini-sidebar")
        ) {
          // --- THU NHỎ SIDEBAR VỀ LẠI ---
          $("body").addClass("mini-sidebar");
          $wrapper.addClass("mini-sidebar");

          // Dọn dẹp style
          $("#sidebar-menu .submenu > ul").removeAttr("style");
          $("#sidebar-menu a").removeClass("subdrop");
        }
      });

      // === 7. MOBILE SIDEBAR (Giữ nguyên) ===
      if ($(".sidebar-overlay").length === 0) {
        $("body").append('<div class="sidebar-overlay"></div>');
      }

      $(document)
        .off("click", "#mobile_btn")
        .on("click", "#mobile_btn", function () {
          $wrapper.toggleClass("slide-nav");
          $(".sidebar-overlay").toggleClass("opened");
          $("html").addClass("menu-opened");
          $("#task_window").removeClass("opened");
          return false;
        });

      $(".sidebar-overlay")
        .off("click")
        .on("click", function () {
          $("html").removeClass("menu-opened");
          $(this).removeClass("opened");
          $wrapper.removeClass("slide-nav");
          $(".sidebar-overlay").removeClass("opened");
          $("#task_window").removeClass("opened");
        });
    },
  },
};
</script>

<style scoped>
/* Thêm CSS fallback cho slimscroll nếu plugin không được tải */
.sidebar-inner.slimscroll {
  height: 100%;
  /* Fallback nếu slimscroll không tải được */
  overflow-y: auto;
}
.mini-sidebar .menu-title {
  display: none;
}
</style>
